'use client';
import { useEffect } from 'react';

export const TmModelHomeDetailClient = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      // Replaces phone number
      window?.Invoca?.PNAPI?.run();
    }
  }, []);

  return null;
};
